<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <ServiceInfo></ServiceInfo>
      <el-row id="con-pbGroup" class="col-lg-10 col-md-11 m-auto">
        <el-button class="col-md-3 col-6" id="con-pageButton1" @click="ToPage1"
          >전속중개계약서 1쪽</el-button
        >
        <el-button
          class="col-md-3 col-6"
          ref="pageButton2"
          id="con-pageButton2"
          @click="ToPage2"
          >전속중개계약서 2쪽</el-button
        >
        <el-button class="col-md-6" id="con-pageButton3" @click="ToPage3"
          >전속중개계약서 별지 (서울특별시 부동산 중개요율표)</el-button
        >
      </el-row>
      <!-- 전속중개계약 1페이지 -->
      <step3-contract1
        ref="contract1"
        v-show="contractNum === 1"
        @SendContract1Data="GetContract1Data"
        @contractNum="contractNum = $event"
        @clientBirth="clientBirth = $event"
      >
      </step3-contract1>

      <!-- 전속중개계약 2페이지 -->
      <step3-contract2
        ref="contract2"
        v-show="contractNum === 2"
        @ToPage1="ToPage1"
        @SendContract2Data="GetContract2Data"
        @contractNum="contractNum = $event"
        :clientBirth="clientBirth"
      >
      </step3-contract2>

      <!-- 전속중개계약 3페이지 -->
      <step3-contract3
        ref="contract3"
        v-show="contractNum === 3"
        @ToPage2="ToPage2"
      >
      </step3-contract3>
    </form>
  </ValidationObserver>
</template>
<script>
import { Row, Button, Tooltip, Upload } from "element-ui";
import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfo.vue";
import Step3Contract1 from "@/pages/components/Jipvio/Step3_Contract1.vue";
import Step3Contract2 from "@/pages/components/Jipvio/Step3_Contract2.vue";
import Step3Contract3 from "@/pages/components/Jipvio/Step3_Contract3.vue";

import { createNamespacedHelpers, mapGetters } from "vuex";

import fontNanumBarunGothic from "@/assets/fonts/NanumBarunGothic.js";
import fontNanumBarunGothicBold from "@/assets/fonts/NanumBarunGothicBold.js";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

import { Checkbox, Message } from "element-ui";
extend("required", required);
extend("numeric", numeric);
extend("true", value => {
  return value == true;
});

extend("isOne", value => {
  return value == "1";
});
// extend('monthly', value => {
//     return value == null;
// });

export default {
  components: {
    ServiceInfo,
    Step3Contract1,
    Step3Contract2,
    Step3Contract3,
    [Row.name]: Row,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Checkbox.name]: Checkbox,
    [Upload.name]: Upload
  },
  data() {
    return {
      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: []
      },
      //contract 1
      leaseCheck: null, //임대 체크

      provideData: null, //정보 공개여부

      brokCompenRate: null, //중개보수 거래가액의 %
      brokCompenPrice: null, //중개보수 가격 (원)

      clientAddr: null, // 중개의뢰인 주소
      clientName: null, // 중개의뢰인 성명
      clientBirth: null, // 중개의뢰인 생년월일
      clientTel: null, // 중개의뢰인 전화번호

      brokerAddr: "서울시 구로구 고척로 89, 1층 일부", //공인중개사 주소
      brokerName: "유소현", //공인중개사 이름
      companyName: "집비오부동산중개", //상호(명칭)
      brokerResNum: "제11530-2020-00050호", //공인중개서 등록번호
      brokerBirth: "1991년 05월 17일", //공인중개사 생년월일
      brokerTel: "02-2688-3244 / 010-4968-4919", //공인중개사 전화번호

      imageUrl: null, //서명 파일Url

      //contract 2
      p2LeaseCheck: null, //page2 권리이전용 구분- 임대 체크박스

      ownerBirth: null, //소유주 생년월일

      buildingAddr: null, //건축물 소재지
      buildYear: null, //건축년도
      buildingArea: null, //건축물 면적
      buildingStruct: null, //건축물 구조
      buildingPurpose: null, //건축물 용도

      otherFee: null, // 은행융자, 권리금, 제세공과금 등

      rightRel: null, // 권리관계
      regulation: null, //거래규제 및 공법상 제한사항
      leaseYn: "1",
      deposit: null, //중개의뢰금액 보증금
      monthlyPay: null, //중개의뢰금액 월세
      etc: null, //그 밖의 사항

      imgPath: null,
      contractNum: 1
    };
  },

  created() {
    console.log("thrid!");
    this.imgPath = `http://${window.location.host}/img`;
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    leaseCheckV() {
      if (this.leaseCheck) {
        return "V";
      } else {
        return null;
      }
    },
    p2LeaseCheckV() {
      if (this.p2LeaseCheck) {
        return "V";
      } else {
        return null;
      }
    },

    ModifiedClientAddr() {
      if (this.ownerFullAddr == null) {
        return null;
      } else if (this.ownerFullAddr.length > 25) {
        return (
          this.ownerFullAddr.substr(0, 25) +
          "\n" +
          this.ownerFullAddr.substr(25)
        );
      } else {
        return this.ownerFullAddr;
      }
    },

    ModifiedBuildingAddr() {
      if (this.certification.fullJAddr == null) {
        return null;
      } else if (this.certification.fullJAddr.length > 34) {
        return (
          this.certification.fullJAddr.substr(0, 34) +
          "\n" +
          this.certification.fullJAddr.substr(34)
        );
      } else {
        return this.certification.fullJAddr;
      }
    },
    ModifiedLandAddr() {
      if (this.certification.propertyJAddr == null) {
        return null;
      } else if (this.certification.propertyJAddr.length > 31) {
        return (
          this.certification.propertyJAddr.substr(0, 31) +
          "\n" +
          this.certification.propertyJAddr.substr(31)
        );
      } else {
        return this.certification.propertyJAddr;
      }
    },

    provideDataLiteral() {
      if (this.provideData == "1") {
        return "공개";
      } else if (this.provideData == "0") {
        return "비공개";
      } else {
        return null;
      }
    },

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    ownerFullAddr() {
      return (
        this.sessionPropertyInquiry.certification.ownerAddr +
        " " +
        this.sessionPropertyInquiry.certification.ownerAddrDetail
      );
    },

    modifiedMonthlyPay() {
      if (this.monthlyPay == null || this.monthlyPay == "") {
        return null;
      } else {
        return "월세: " + this.monthlyPay + "원";
      }
    },

    today() {
      let today = new Date();
      return {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate()
      };
    },

    contrValDay() {
      let cvDay = new Date();
      cvDay.setMonth(cvDay.getMonth() + 3);
      cvDay.setDate(cvDay.getDate() - 1);
      // let contrvUTC = new Date(
      //   cvDay.getTime() + cvDay.getTimezoneOffset() * 60000
      // );

      const contrvUTC = this.$moment(contrvUTC).format("YYYY-MM-DD HH:mm:ss");

      return {
        cvUTC: contrvUTC,
        year: cvDay.getFullYear(),
        month: cvDay.getMonth() + 1,
        date: cvDay.getDate()
      };
    },

    brdListForPdf() {
      let brdL = "";
      const OrgingBrdL = this.certification.brdList;
      if (OrgingBrdL != null) {
        if (OrgingBrdL.length == 1) {
          return OrgingBrdL[0];
        } else {
          for (var i = 0; i < OrgingBrdL.length - 1; i++) {
            brdL = brdL + OrgingBrdL[i] + ",";
          }
          return brdL + OrgingBrdL[OrgingBrdL.length - 1];
        }
      } else {
        return null;
      }
    },

    modifiedbrdList() {
      if (this.brdListForPdf == null) {
        return null;
      } else if (
        this.brdListForPdf.length > 12 &&
        this.brdListForPdf.length <= 20
      ) {
        return (
          this.brdListForPdf.substr(0, 12) +
          "\n" +
          this.brdListForPdf.substr(12)
        );
      } else if (this.brdListForPdf.length > 20) {
        return (
          this.brdListForPdf.substr(0, 12) +
          "\n" +
          this.brdListForPdf.substr(12, 13) +
          "\n" +
          this.brdListForPdf.substr(13)
        );
      } else {
        return this.brdListForPdf;
      }
    },

    finalUseArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.useArea;
      }
    },

    paymentType() {
      if (this.leaseYn == "1") {
        return "DB";
      } else {
        return "MP";
      }
    },

    paymentTypeStr() {
      if (this.leaseYn == "1") {
        return "전세";
      } else {
        return "월세";
      }
    },
    type() {
      if (this.leaseCheck == true) {
        return "LEA";
      } else {
        return null;
      }
    }
  },

  methods: {
    GetContract1Data(data) {
      (this.leaseCheck = data.leaseCheck),
        (this.provideData = data.provideData),
        (this.brokCompenRate = data.brokCompenRate),
        (this.brokCompenPrice = data.brokCompenPrice),
        (this.clientAddr = data.clientAddr),
        (this.clientName = data.clientName),
        (this.clientTel = data.clientTel),
        (this.imageUrl = data.imageUrl),
        (this.contractNum = data.contractNum),
        (this.clientBirth = data.clientBirth);
    },

    GetContract2Data(data) {
      (this.p2LeaseCheck = data.p2LeaseCheck),
        (this.ownerBirth = data.ownerBirth),
        (this.buildingAddr = data.buildingAddr),
        (this.buildYear = data.buildYear),
        (this.buildingArea = data.buildingArea),
        (this.buildingStruct = data.buildingStruct),
        (this.buildingPurpose = data.buildingPurpose),
        (this.otherFee = data.otherFee),
        (this.rightRel = data.rightRel),
        (this.regulation = data.regulation),
        (this.leaseYn = data.leaseYn),
        (this.deposit = data.deposit),
        (this.monthlyPay = data.monthlyPay),
        (this.etc = data.etc),
        (this.contractNum = data.contractNum);
    },

    bringComponentData() {
      this.$refs["contract1"].SendContract1Data();
      this.$refs["contract2"].SendContract2Data();
    },

    ...sessionMapActions(["savePropertyInquiryStep3"]),

    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = error => {
          reject(error);
        };
        img.src = url;
      });
    },

    saveStep() {
      this.saveStep3Info();
    },

    saveStep3Info() {
      console.log("step3 Action!");
      this.bringComponentData();
      let contractInfo = {
        //contract 1
        p1LeaseCheck: this.leaseCheck, //임대 체크
        type: this.type, // 임대, 임차 ... code from coCode

        provideData: Boolean(Number(this.provideData)), //정보 공개여부

        contrValYear: Number(this.contrValDay.year), //계약 유효기간 년
        contrValMonth: Number(this.contrValDay.month), //월
        contrValDay: Number(this.contrValDay.date), //일
        contrValUTC: this.contrValDay.cvUTC, // 계약 만료일 UTC

        brokCompenRate: Number(this.brokCompenRate), //중개보수 거래가액의 %
        brokCompenPrice: Number(this.brokCompenPrice), //중개보수 가격 (원)

        writeYear: Number(this.today.year), // 계약서 작성일 년도
        writeMonth: Number(this.today.month), // 계약서 작성일 월
        writeDay: Number(this.today.date), // 계약서 작성일 일

        clientAddr: this.ownerFullAddr, // 중개의뢰인 주소  ==> computed
        clientName: this.certification.ownerName, // 중개의뢰인 성명
        clientBirth: this.clientBirth, // 중개의뢰인 생년월일
        clientTel: this.certification.ownerTel, // 중개의뢰인 전화번호

        brokerAddr: this.brokerAddr, //공인중개사 주소
        brokerName: this.brokerName, //공인중개사 이름
        companyName: this.companyName, //상호(명칭)
        brokerResNum: this.brokerResNum, //공인중개사 등록번호
        brokerBirth: this.brokerBirth, //공인중개사 생년월일
        brokerTel: this.brokerTel, //공인중개사 전화번호

        imageUrl: this.imageUrl, //서명 파일Url

        //contract 2
        p2LeaseCheck: this.p2LeaseCheck, //page2 권리이전용 구분- 임대 체크박스

        buildingAddr: this.certification.fullJAddr, //건축물 소재지
        buildYear: this.certification.buildYear, //건축년도
        buildingArea: this.finalUseArea, //건축물 면적
        buildingStruct: this.certification.strct, //건축물 구조
        buildingPurpose: this.certification.purpsDetail, //건축물 용도

        landAddr: this.certification.propertyJAddr, //토지 소재지
        landPurpose: this.certification.platGbCdNm, //토지 지목
        landArea: this.certification.platArea, //토지 면적
        landPlace: this.certification.brdList, //토지 지역,지구 등
        landPrstPurp: this.certification.platGbCdNm, //토지 현재 용도

        otherFee: this.otherFee, // 은행융자, 권리금, 제세공과금 등

        rightRel: this.rightRel, // 권리관계
        regulation: this.regulation, //거래규제 및 공법상 제한사항
        leaseYn: Boolean(Number(this.leaseYn)), //거래유형(전세 =true, 월세 = false)
        paymentType: this.paymentType, //전세, 월세 id from coCode
        deposit: this.deposit, //중개의뢰금액 보증금
        monthlyPay: Number(this.monthlyPay), //중개의뢰금액 월세
        etc: this.etc //그 밖의 사항
      };

      this.savePropertyInquiryStep3(contractInfo);
      console.log(this.sessionPropertyInquiry);
    },

    ToPage1() {
      this.contractNum = 1;
      window.scrollTo(0, 420);
    },

    ToPage2() {
      this.$refs.contract1.ToPage2();
      window.scrollTo(0, 420);
    },

    ToPage3() {
      this.$refs.contract2.ToPage3();
    },

    // async showMessage() {
    //   let errMsg = [];

    //   let res = await this.$refs["contract1"].$refs.leaseCheckVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "1페이지 상단 임대 체크박스를 확인해주세요.",
    //       ref: "leaseCheckBox",
    //       IsfocusRequireEl: false,
    //       pageNum: 1
    //     });
    //   }

    //   res = await this.$refs["contract1"].$refs.provideDataVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "1페이지 정보공개 여부를 확인해주세요.",
    //       ref: "provideDataSelect",
    //       IsfocusRequireEl: false,
    //       pageNum: 1
    //     });
    //   }

    //   res = await this.$refs["contract2"].$refs.p2LeaseCheckVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "2페이지 구분에 임대 체크박스를 확인해주세요.",
    //       ref: "p2LeaseCheckBox",
    //       IsfocusRequireEl: false,
    //       pageNum: 2
    //     });
    //   }

    //   res = await this.$refs["contract2"].$refs.otherFeeVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message:
    //         "2페이지 구분에 중개대상물(은행융자, 권리금, 제세공과금 등)를 확인해주세요.",
    //       ref: "otherFeeBox",
    //       IsfocusRequireEl: false,
    //       pageNum: 2
    //     });
    //   }

    //   res = await this.$refs["contract2"].$refs.rightRelVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "2페이지 권리관계를 확인해주세요.",
    //       ref: "rightRelBox",
    //       IsfocusRequireEl: false,
    //       pageNum: 2
    //     });
    //   }

    //   res = await this.$refs["contract2"].$refs.depositVal.validate();
    //   if (!res.valid) {
    //     errMsg.push({
    //       message: "2페이지 보증금을 확인해주세요.",
    //       ref: "depositBox",
    //       IsfocusRequireEl: false,
    //       pageNum: 2
    //     });
    //   }

    //   if (Number(this.leaseYn) === 0) {
    //     res = await this.$refs["contract2"].$refs.monthlyPayVal.validate();
    //     if (!res.valid) {
    //       errMsg.push({
    //         message: "2페이지 월세를 확인해주세요.",
    //         ref: "monthlyPayBox",
    //         IsfocusRequireEl: false,
    //         pageNum: 2
    //       });
    //     }
    //   }

    //   if (errMsg[0] != null) {
    //     let Num = errMsg[0].pageNum;
    //     this.contractNum = Num;
    //     this.$nextTick(() => {
    //       this.$refs["contract" + Num].$refs[errMsg[0].ref].focus();
    //     });
    //     Message({
    //       message: errMsg[0].message,
    //       type: "error"
    //     });
    //   }

    //   if (errMsg[1] != null) {
    //     Message({
    //       message: errMsg[1].message,
    //       type: "error",
    //       offset: 60
    //     });
    //   }

    //   if (errMsg[2] != null) {
    //     Message({
    //       message: errMsg[2].message,
    //       type: "error",
    //       offset: 100
    //     });
    //   }
    // },

    showMessage(ValId) {
      if (ValId == "leaseCheckVal") {
        return "1페이지 상단 임대 체크박스를 확인해주세요.";
      } else if (ValId == "provideDataVal") {
        return "1페이지 정보공개 여부를 확인해주세요.";
      } else if (ValId == "p2LeaseCheckVal") {
        return "2페이지 구분에 임대 체크박스를 확인해주세요.";
      } else if (ValId == "otherFeeVal") {
        return "2페이지 구분에 중개대상물(은행융자, 권리금, 제세공과금 등)를 확인해주세요.";
      } else if (ValId == "rightRelVal") {
        return "2페이지 권리관계를 확인해주세요.";
      } else if (ValId == "depositVal") {
        return "2페이지 보증금을 확인해주세요.";
      } else if (ValId == "monthlyPayVal") {
        return "2페이지 월세를 확인해주세요.";
      }
    },

    validate() {
      return this.$refs.form.validate().then(async isValid => {
        if (!isValid) {
          // 에러가 발생한 부분만 Array로 만들기
          const errors = Object.entries(this.$refs.form.errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error["value"].length);

          if (
            // 컴포넌트 contract1에 오류가 있을 경우 contract1 이동
            errors[0]["key"] == "leaseCheckVal" ||
            errors[0]["key"] == "provideDataVal"
          ) {
            this.contractNum = 1;
          } else {
            // 컴포넌트 contract2에 오류가 있을 경우 contract2 이동
            this.contractNum = 2;
          }
          for (let i = 0; i < errors.length; i++) {
            Message({
              message: this.showMessage(errors[i]["key"]),
              type: "error",
              offset: (i + 1) * 35
            });
          }
          setTimeout(() => {
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }, 100);
          return;
        }

        // if (
        //   this.leaseYn == "0" &&
        //   (this.monthlyPay == null ||
        //     this.monthlyPay == "" ||
        //     this.monthlyPay == 0)
        // ) {
        //   this.contractNum = 2;
        //   document.getElementById("con2-line11-div3-input1").focus();
        //   Message.error("2페이지 월세를 입력해주세요.");
        //   return;
        // }
        this.$emit("on-validated", isValid);
        this.scrollToTop();
        this.saveStep3Info();
        return isValid;
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    // scrollTo30() {
    //   window.scrollTo(30, 30);
    // },

    //step1 method

    onClickImageUpload() {
      this.$refs.imageInput.click();
    },
    onChangeImages(e) {
      console.log(e.target.files);
      const file = e.target.files[0]; // Get first index in files
      this.imageUrl = URL.createObjectURL(file); // Create File
      console.log(this.imageUrl);
    },

    //======================================================
    // generarPDF: function () {
    //   // change q-img src component and it works !!!
    //   this.testImg = "img/cov1.jpg"

    //   // opens new window with pdf content
    //   pdfMake.createPdf(docDef(this.test)).open()
    // },

    async createPdfFile() {
      let imgUrl = "";

      if (this.imageUrl != null) {
        imgUrl = await this.getBase64ImageFromURL(this.imageUrl);
      }

      pdfMake.vfs.NanumBarunGothic = fontNanumBarunGothic[0].NanumBarunGothic;
      pdfMake.vfs.NanumBarunGothicBold =
        fontNanumBarunGothicBold[0].NanumBarunGothicBold;

      pdfMake.fonts = {
        NanumBarunGothic: {
          normal: "NanumBarunGothic",
          bold: "NanumBarunGothicBold",
          italics: "NanumBarunGothic",
          bolditalics: "NanumBarunGothicBold"
        }
      };
      let docDefinition = {
        pageSize: "A4",
        //pageOrientation: "landscape",
        //pageMargins: [40, 60, 40, 60],
        defaultStyle: {
          font: "NanumBarunGothic"
        },

        background: function(page) {
          if (page == 1) {
            return [
              {
                image: "contract1",
                fit: [600, 2000]
              }
            ];
          } else if (page == 2) {
            return [
              {
                image: "contract2",
                fit: [600, 2000]
              }
            ];
          } else {
            return [
              {
                image: "contract3",
                fit: [600, 2000]
              }
            ];
          }
        },
        content: [
          {
            // 임대 체크박스
            text: this.leaseCheckV,
            // fontSize: 50,
            absolutePosition: { x: 227, y: 110 }
          },
          {
            // 공개 비공개 여부
            text: this.provideDataLiteral,
            fontSize: 9,
            absolutePosition: { x: 174, y: 244.5 }
          },
          {
            // 계약 유효기간 년도
            text: this.contrValDay.year,
            fontSize: 9,
            absolutePosition: { x: 185, y: 413.5 }
          },
          {
            // 계약 유효기간 월
            text: this.contrValDay.month,
            fontSize: 9,
            absolutePosition: { x: 239, y: 413.5 }
          },

          {
            // 계약 유효기간 일
            text: this.contrValDay.date,
            fontSize: 9,
            absolutePosition: { x: 276, y: 413.5 }
          },
          {
            // 중개보수 %
            text: this.brokCompenRate,
            fontSize: 9,
            absolutePosition: { x: 334, y: 455 }
          },
          {
            // 중개보수 원
            text: this.brokCompenPrice,
            fontSize: 9,
            absolutePosition: { x: 375, y: 444 }
          },
          {
            // 작성일 년도
            text: this.today.year,
            fontSize: 9,
            absolutePosition: { x: 426, y: 605.5 }
          },
          {
            // 작성일 월
            text: this.today.month,
            fontSize: 9,
            absolutePosition: { x: 477, y: 605.5 }
          },
          {
            // 작성일 일
            text: this.today.date,
            fontSize: 9,
            absolutePosition: { x: 515, y: 605.5 }
          },
          {
            // 중개의뢰인 주소
            text: this.ModifiedClientAddr,
            fontSize: 8,
            absolutePosition: { x: 183, y: 644 }
          },
          {
            // 중개의뢰인 성명
            text: this.certification.ownerName,
            fontSize: 9,
            absolutePosition: { x: 420, y: 647 }
          },
          {
            // 중개의뢰인 서명란
            image: imgUrl,
            width: 50,
            height: 23,
            absolutePosition: { x: 490, y: 640 }
          },
          {
            // 중개의뢰인 생년월일
            text: this.clientBirth,
            fontSize: 9,
            absolutePosition: { x: 185, y: 670 }
          },
          {
            // 중개의뢰인 전화번호
            text: this.certification.ownerTel,
            fontSize: 9,
            absolutePosition: { x: 420, y: 670 }
          },
          {
            // 개업 공인중개사 주소
            text: this.brokerAddr,
            fontSize: 9,
            absolutePosition: { x: 185, y: 694 }
          },
          {
            // 개업 공인중개사 성명
            text: this.brokerName,
            fontSize: 9,
            absolutePosition: { x: 420, y: 694 }
          },
          {
            // 개업 공인중개사 상호
            text: this.companyName,
            fontSize: 9,
            absolutePosition: { x: 185, y: 717 }
          },
          {
            // 개업 공인중개사 등록번호
            text: this.brokerResNum,
            fontSize: 9,
            absolutePosition: { x: 420, y: 717 }
          },
          {
            // 개업 공인중개사 생년월일
            text: this.brokerBirth,
            fontSize: 9,
            absolutePosition: { x: 185, y: 740 }
          },
          {
            // 개업 공인중개사 전화번호
            text: this.brokerTel,
            fontSize: 9,
            absolutePosition: { x: 420, y: 737 }
          },
          {
            text: "",
            pageBreak: "after"
          },

          //2페이지===========================================================
          {
            //권리이전용 임대 체크박스
            text: this.p2LeaseCheckV,
            absolutePosition: { x: 203, y: 169 }
          },
          {
            //소유자 및 등기명의인 성명
            text: this.certification.ownerName,
            fontSize: 9,
            absolutePosition: { x: 170, y: 192 }
          },
          {
            //소유자 및 등기명의인 생년월일
            text: this.clientBirth,
            fontSize: 9,
            absolutePosition: { x: 415, y: 192 }
          },
          {
            //소유자 및 등기명의인 주소
            text: this.ownerFullAddr,
            fontSize: 8,
            absolutePosition: { x: 170, y: 216 }
          },
          {
            //중개대상물 (건축물) 소재지
            text: this.ModifiedBuildingAddr,
            fontSize: 8,
            absolutePosition: { x: 208, y: 240 }
          },
          {
            //중개대상물 (건축물) 건축년도
            text: this.certification.buildYear,
            fontSize: 9,
            absolutePosition: { x: 475, y: 244 }
          },
          {
            //중개대상물 (건축물) 면적
            text: this.finalUseArea,
            fontSize: 9,
            absolutePosition: { x: 208, y: 268 }
          },
          {
            //중개대상물 (건축물) 구조
            text: this.certification.strct,
            fontSize: 9,
            absolutePosition: { x: 335, y: 268 }
          },
          {
            //중개대상물 (건축물) 용도
            text: this.certification.purpsDetail,
            fontSize: 9,
            absolutePosition: { x: 465, y: 268 }
          },
          {
            //중개대상물 (토지) 소재지
            text: this.ModifiedLandAddr,
            fontSize: 8,
            absolutePosition: { x: 208, y: 289 }
          },
          {
            //중개대상물 (토지) 지목
            text: this.certification.platGbCdNm,
            fontSize: 9,
            absolutePosition: { x: 465, y: 291 }
          },
          {
            //중개대상물 (토지) 면적
            text: this.certification.platArea,
            fontSize: 9,
            absolutePosition: { x: 208, y: 316 }
          },
          {
            //중개대상물 (토지) 지역,지구 등
            text: this.modifiedbrdList,
            fontSize: 8,
            absolutePosition: { x: 344, y: 313 }
          },
          {
            //중개대상물 (토지) 현재 용도
            text: this.certification.platGbCdNm,
            fontSize: 9,
            absolutePosition: { x: 480, y: 316 }
          },
          {
            //중개대상물 - 은행융자, 권리금, 제세공과금 등
            text: this.otherFee,
            fontSize: 9,
            absolutePosition: { x: 147, y: 351 }
          },
          {
            //권리관계
            text: this.rightRel,
            fontSize: 9,
            absolutePosition: { x: 147, y: 389 }
          },
          {
            //거래규제 및 공법상 제한사항
            text: this.regulation,
            fontSize: 8,
            absolutePosition: { x: 147, y: 410 }
          },
          {
            //전세 or 월세
            text: this.paymentTypeStr,
            fontSize: 9,
            absolutePosition: { x: 143, y: 438 }
          },
          {
            //중개의뢰 금액 (보증금)
            text: "보증금: " + this.deposit,
            fontSize: 9,
            absolutePosition: { x: 240, y: 438 }
          },
          {
            //중개의뢰 금액 (월세)
            text: this.modifiedMonthlyPay,
            fontSize: 9,
            absolutePosition: { x: 400, y: 438 }
          },
          {
            //그 밖의 사항
            text: this.etc,
            fontSize: 8,
            absolutePosition: { x: 147, y: 459 }
          },

          {
            text: "",
            pageBreak: "after"
          },
          //3페이지===============================================================
          {
            // 매매 교환 9억원 이상
            text: this.houseOver900mil,
            fontSize: 9,
            absolutePosition: { x: 210, y: 287.5 }
          },
          {
            //임대차 등(매매 교환 이외) 6억원 이상
            text: this.houseOver600mil,
            fontSize: 9,
            absolutePosition: { x: 210, y: 415 }
          },
          {
            //오피스텔 적용대상 외의 경우 상한 요율
            text: this.offiMaxRate,
            fontSize: 9,
            absolutePosition: { x: 352.5, y: 572 }
          },
          {
            //주택 오피스텔 외 상한요율
            text: this.otherMaxRate,
            fontSize: 9,
            absolutePosition: { x: 209, y: 698 }
          }
        ],

        images: {
          contract1: this.imgPath + "/contract1.jpg",
          contract2: this.imgPath + "/contract2.jpg",
          contract3: this.imgPath + "/contract3.jpg"
        },
        styles: {
          docTitle: {}
        }
      };

      pdfMake.tableLayouts = {};

      // pdf 형식 다운로드
      //pdfMake.createPdf(docDefinition).download("test.pdf");
      pdfMake.createPdf(docDefinition).open();
    }
  }
};
</script>
<style>
body {
  font-size: 16px;
}
.wrapper {
  width: 100%;
}

#con-pbGroup {
  margin: 0;
}
#con-pbGroup button {
  margin: 0;
}

.contract {
  margin: auto;
  width: 100%;
  position: relative;
  border: 1px ridge #e6e6e6;
}

img {
  display: block;
  width: 100%;
}

/* 공통 */
.con-line {
  position: absolute;
  width: 100%;
  height: 2%;
  /* background-color: #ff000080; */
}
.con-line input {
  height: 100%;
  top: 0;
  background-color: #c7ffff;
  border: 1px #00ffff80 solid;
}
.con-line input:disabled {
  background-color: #c9c9c980;
  border: 1px #c9c9c9;
}
/*radio*/

.con-line-div {
  position: absolute;
}

.con-line-input {
  position: absolute;
  top: 6%;
  width: 100%;
  height: 90%;
}
/* ----------------------------------------------------계약서1 */

/* --------------------------------------계약서1 - line1 */
#con1-line1 {
  top: 12.8%;
}

/* 매도 체크박스*/
#con1-line1-div1 {
  width: 3%;
  height: 100%;
  top: 0%;
  left: 13%;
}

/* 매수 체크박스 */
#con1-line1-div2 {
  width: 3%;
  height: 100%;
  top: 0%;
  left: 25%;
}

/* 임대 체크박스 */
#con1-line1-div3 {
  width: 3%;
  height: 100%;
  top: 0%;
  left: 37%;
}

/* 임차 체크박스 */
#con1-line1-div4 {
  width: 3%;
  height: 100%;
  top: 0%;
  left: 49%;
}

/* 그 밖의 계약 체크박스 */
#con1-line1-div5 {
  width: 2.5%;
  height: 100%;
  top: 0%;
  left: 61%;
}

/* 그 밖의 계약 설명 인풋박스 */
#con1-line1-div6 {
  width: 7%;
  height: 100%;
  top: 0%;
  left: 81%;
}

/* --------------------------------------계약서1 - line2 */
#con1-line2 {
  top: 28.1%;
  height: 2.5%;
}

/* 공개 비공개 선택후 글씨 */
#con1-line2-div1 {
  width: 7%;
  height: 100%;
  top: 0%;
  left: 28.1%;
  background-color: #00ffff40;
  border: 1px #00ffff80 solid;
}

#con1-line2-div1-p1 {
  position: absolute;
  top: 0;
  font-size: 1.5vw;
  line-height: 2;
}

/* 비공개 여부 */
#con1-line2-div2 {
  width: 10%;
  height: 100%;
  top: 0%;
  left: 37.6%;
}

#con1-line2-div2-select1 {
  position: absolute;
  top: 0%;
  width: 100%;
  height: 100%;
}

/* 공개여부 선택박스 hover시 안내 */
/* #divinput1Info {
  display: none;
  position: absolute;
  width: 80%;
  top: 6%;
  left: 50.5%;
} */

/* #line2 > #divinput2:hover ~ #divinput1Info {
  display: block;
} */

/* --------------------------------------계약서1 - line3 */

#con1-line3 {
  top: 48.4%;
}

/*계약 유효기간 년도 */
#con1-line3-div1 {
  width: 7.3%;
  height: 100%;
  top: 0%;
  left: 29.1%;
}

/*계약 유효기간 월 */
#con1-line3-div2 {
  width: 4%;
  height: 100%;
  top: 0%;
  left: 38.7%;
}

/* 계약 유효기간 일 */
#con1-line3-div3 {
  width: 4%;
  height: 100%;
  top: 0%;
  left: 44.8%;
}

/*------------------------- 계약서1- line4 */
#con1-line4 {
  top: 53.4%;
}

/*중개보수는 거래가액의 ()% */
#con1-line4-div1 {
  width: 2.5%;
  height: 100%;
  top: 0%;
  left: 55.3%;
}

/*(또는 ___ 원) */
#con1-line4-div2 {
  width: 2.5%;
  height: 100%;
  top: 0%;
  left: 63%;
}
#con1-line4-div3-info {
  right: 6.5%;
}
/*--------------------------- 계약서1-line5 */
#con1-line5 {
  top: 71%;
}

/*계약서 작성일 년도 */
#con1-line5-div1 {
  width: 7.2%;
  height: 100%;
  top: 0%;
  left: 68.8%;
}

/*계약서 작성일 월 */
#con1-line5-div2 {
  width: 4%;
  height: 100%;
  top: 0%;
  left: 78.3%;
}

/* 계약서 작성일 일 */
#con1-line5-div3 {
  width: 4%;
  height: 100%;
  top: 0%;
  left: 84.6%;
}

/*------------------------------- 계약서1-line6 */

#con1-line6 {
  position: absolute;
  width: 100%;
  height: 2.7%;
  top: 75.4%;
}

.con1-line6-input {
  position: absolute;
  top: 0%;
  width: 100%;
  height: 100%;
}

/*중개의뢰인 주소 */
#con1-line6-div1 {
  width: 29%;
  height: 100%;
  top: 0%;
  left: 30.5%;
}

/*중개의뢰인 성명*/
#con1-line6-div2 {
  width: 12%;
  height: 100%;
  top: 0%;
  left: 69%;
}

/*중개의뢰인 서명 업로드 버튼*/
#con1-line6-div3 {
  width: 19%;
  height: 130%;
  bottom: 52%;
  right: 0%;
  font-size: 1.5vw;
}
input#con1-line6-sign {
  width: 100%;
  background-color: #5a2fca;
  color: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
  outline: 0;
  border: none;
}

/*서명 이미지*/
#con1-line6-div4 {
  width: 7%;
  height: 100%;
  top: 0%;
  left: 82.5%;
}

#con1-line6-div4-img1 {
  position: absolute;
  top: 0%;
  width: 100%;
  height: 100%;
}

/*----------------------------- 계약서1-line7 */

#con1-line7 {
  top: 78.2%;
  height: 2.7%;
}
#con1-line7 input {
  top: 0;
  height: 100%;
}

/*중개의뢰인 생년월일 */
#con1-line7-div1 {
  width: 29%;
  height: 100%;
  top: 0%;
  left: 30.5%;
}

/*중개의뢰인 전화번호*/
#con1-line7-div2 {
  width: 18%;
  height: 100%;
  top: 0%;
  left: 69%;
}

/*------------------------------- 계약서1-line8 */
#con1-line8 {
  position: absolute;
  width: 100%;
  height: 2.7%;
  top: 80.9%;
}

.con1-line8-input {
  position: absolute;
  top: 15%;
  width: 100%;
  height: 70%;
}

/*공인중개사 주소 */
#con1-line8-div1 {
  width: 29%;
  height: 100%;
  top: 0%;
  left: 30.5%;
}

/*공인중개사 성명*/
#con1-line8-div2 {
  width: 12%;
  height: 100%;
  top: 0%;
  left: 69%;
}

/* ----------------------------------계약서1-line9 */
#con1-line9 {
  top: 83.6%;
  height: 2.8%;
}

/*공인중개사 상호(명칭) */
#con1-line9-div1 {
  width: 29%;
  height: 100%;
  top: 0%;
  left: 30.5%;
}

/*공인중개사 등록번호*/
#con1-line9-div2 {
  width: 18%;
  height: 100%;
  top: 0%;
  left: 69%;
}

/* -----------------------------계약서1-line10 */

#con1-line10 {
  top: 86.4%;
  height: 2.7%;
}

/*공인중개사 생년월일 */
#con1-line10-div1 {
  width: 29%;
  height: 100%;
  top: 0%;
  left: 30.5%;
}

/*공인중개사 전화번호*/
#con1-line10-div2 {
  width: 18%;
  height: 100%;
  top: 0%;
  left: 69%;
}

/* ------------------------------계약서1-line11 */
/*다음 버튼*/

#con1-line11 {
  top: 95.6%;
}

#con1-line11-div1 {
  /* width: 15%; */
  height: 100%;
  top: 0%;
  right: 125px;
}

#con1-line11-nextButton {
  position: absolute;
  width: 125px;
  min-width: 125px;
  margin: 0;
  background-color: #5a2fca;
}
/* ----------------------------------------------------계약서2 */
/* 권리이전용(매도 임대)*/
#con2-line1 {
  top: 19.2%;
  height: 2.8%;
}

/* 매도 체크박스 */
#con2-line1-div1 {
  width: 2%;
  height: 100%;
  top: 0%;
  left: 24.2%;
}

/* 임대 체크박스 */
#con2-line1-div2 {
  width: 2%;
  height: 100%;
  top: 0%;
  left: 33.3%;
}

/* 그 밖의 사항  체크박스 */
#con2-line1-div3 {
  width: 2%;
  height: 100%;
  top: 0%;
  left: 42.4%;
}

/*그 밖의 사항 설명 인풋박스 */
#con2-line1-div4 {
  width: 25%;
  height: 95%;
  top: 3%;
  left: 55.5%;
}
#con2-line1-div4 input {
  width: 100%;
}

/*------------------------------------------ 계약서2-line2 */
#con2-line2 {
  top: 22.1%;
  height: 2.8%;
}

/* 소유자 성명 */
#con2-line2-div1 {
  width: 20%;
  height: 100%;
  top: 0%;
  left: 28%;
}

/*소유자  생년월일 */
#con2-line2-div2 {
  width: 21.5%;
  height: 100%;
  top: 0%;
  left: 68%;
}

/*------------------------------------------- 계약서2-line3 */
#con2-line3 {
  top: 25%;
  height: 2.8%;
}

/* 소유자 주소 */
#con2-line3-div1 {
  width: 61.5%;
  height: 100%;
  top: 0%;
  left: 28%;
}

/* ------------------------------------------계약서2-line4 */
#con2-line4 {
  top: 27.8%;
  height: 2.8%;
}

/*  건축물 소재지 */
#con2-line4-div1 {
  width: 38%;
  height: 100%;
  top: 0%;
  left: 34%;
}

/*  건축년도 */
#con2-line4-div2 {
  width: 10.5%;
  height: 100%;
  top: 0%;
  left: 79%;
}

/*------------------------------------------ 계약서2-line5 */
#con2-line5 {
  top: 30.7%;
  height: 2.8%;
}

/*건축물 면적*/
#con2-line5-div1 {
  width: 14%;
  height: 100%;
  top: 0%;
  left: 34%;
}

/*건축물 구조 */
#con2-line5-div2 {
  width: 16.5%;
  height: 100%;
  top: 0%;
  left: 55.5%;
}

/* 건축물 용도 */
#con2-line5-div3 {
  width: 13%;
  height: 100%;
  top: 0%;
  left: 76.5%;
}

/* -----------------------------계약서2-line6 */
/* 토지 */
#con2-line6 {
  top: 33.5%;
  height: 2.8%;
}

/* 소재지 */
#con2-line6-div1 {
  width: 38%;
  height: 100%;
  top: 0%;
  left: 34%;
}

/* 지목 */
#con2-line6-div2 {
  width: 13%;
  height: 100%;
  top: 0%;
  left: 76.5%;
}

/* ----------------------------계약서2-line7 */
#con2-line7 {
  top: 36.4%;
  height: 2.8%;
}

/*토지 면적 */
#con2-line7-div1 {
  width: 14%;
  height: 100%;
  top: 0%;
  left: 34%;
}

/*토지 지역 */
#con2-line7-div2 {
  width: 15%;
  height: 100%;
  top: 0%;
  left: 57%;
}

/*토지 용도 */
#con2-line7-div3 {
  width: 10%;
  height: 100%;
  top: 0%;
  left: 79.5%;
}

/* -----------------------------계약서2-line8 */
#con2-line8 {
  top: 41.8%;
  height: 3%;
}

/*은행융자, 권리금, 제세공과금*/
#con2-line8-div1 {
  width: 65.5%;
  height: 100%;
  top: 0%;
  left: 23.5%;
}

/* ----------------------------------계약서2-line9 */
#con2-line9 {
  top: 45.1%;
  height: 2.8%;
}

/*권리관계 */
#con2-line9-div1 {
  width: 65.5%;
  height: 100%;
  top: 0%;
  left: 23.5%;
}

/* ---------------------------------계약서2-line10 */

#con2-line10 {
  top: 48%;
  height: 2.8%;
}

/*거래규제 및 공법상 제한사항 */
#con2-line10-div1 {
  width: 65.5%;
  height: 100%;
  top: 0%;
  left: 23.5%;
}

/* ------------------------------------계약서2-line11 */
#con2-line11 {
  top: 50.8%;
  height: 2.8%;
}

/*중개의뢰 금액 보증금*/
#con2-line11-div1 {
  position: absolute;
  width: 14%;
  height: 100%;
  top: 0%;
  left: 23.5%;
}
#con2-line11-div1 > select {
  height: 100%;
  width: 100%;
}
select#yearent label {
  color: red;
}

#con2-line11-div2 {
  width: 30%;
  height: 100%;
  top: 0%;
  left: 39%;
}

#con2-line11-div2-input1 {
  width: 56%;
  height: 100%;
}

#con2-line11-div3 {
  width: 25%;
  height: 100%;
  top: 0%;
  right: 3%;
}

#con2-line11-div3-span1 {
  position: absolute;
  padding-top: 4%;
}

#con2-line11-div3-input1 {
  width: 58%;
}

/* ---------------------------계약서2-line12 */
#con2-line12 {
  top: 53.7%;
  height: 2.7%;
}

/*그 밖의 사항*/
#con2-line12-div1 {
  width: 65.5%;
  height: 100%;
  top: 0%;
  left: 23.5%;
}

/*이전, 다음 버튼*/

#con2-line13 {
  top: 95.6%;
}

#con2-line13-div1 {
  width: 15%;
  height: 100%;
  top: 0%;
  left: 0;
}

#con2-line13 .con2-line13-btn {
  font-size: 0.9vw;
  position: absolute;
  width: 125px;
  min-width: 125px;
  margin: 0;
  background-color: #5a2fca;
  color: #ffffff;
}

#con2-line13-div2 {
  height: 100%;
  top: 0%;
  right: 125px;
}

/* ----------------------------------------------------계약서3 */
#con3-line1 {
  top: 33.4%;
}

/*  매매교환 9억원 이상 */
#con3-line1-div1 {
  width: 2.8%;
  height: 100%;
  top: 0%;
  left: 34.1%;
}

#con3-line2 {
  top: 48.4%;
}

/*  매매교환 9억원 이상 */
#con3-line2-div1 {
  width: 2.8%;
  height: 100%;
  top: 0%;
  left: 34.1%;
}

#con3-line3 {
  top: 67%;
}

/*  오피스텔 위 적용대상 외의 경우 상한요율 */
#con3-line3-div1 {
  width: 2.6%;
  height: 100%;
  top: 0%;
  left: 58%;
}

#con3-line4 {
  top: 81.8%;
}
/* 주택 오피스텔 외(토지 상가 등)*/
#con3-line4-div1 {
  width: 2.5%;
  height: 100%;
  top: 0%;
  left: 34.1%;
}

/*이전 버튼*/

#con3-line5 {
  top: 95.6%;
}

#con3-line5-div1 {
  height: 100%;
  top: 0%;
  left: 0;
}

#con3-line5-prevButton {
  font-size: 1vw;
  position: absolute;
  width: 125px;
  min-width: 125px;
  margin: 0;
  background-color: #5f27f8;
  color: #ffffff;
}

#con1-line6-div3 .upload-demo {
  position: relative;
}
#con1-line6-div3 .upload-demo .el-upload-list {
  position: absolute;
  width: 55%;
  height: 100%;
}
#con1-line6-div3 .upload-demo .el-upload-list .el-upload-list__item {
  margin-top: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#con1-line6-div3
  .upload-demo
  .el-upload-list
  .el-upload-list__item
  .el-upload-list__item-thumbnail {
  width: 70%;
  height: 100%;
  object-fit: cover;
  margin-left: 0;
  padding-top: 2px;
}

#con1-line6-div3
  .upload-demo
  .el-upload-list
  .el-upload-list__item
  .el-icon-close {
  z-index: 10;
}
#con1-line6-div3
  .upload-demo
  .el-upload-list
  .el-upload-list__item
  .el-upload-list__item-name {
  display: none;
}
@media screen and (max-width: 1199px) {
  #con1-line6-div3 .upload-demo .el-upload-list {
    height: 130%;
  }
  @media screen and (max-width: 991px) {
    #con1-line6-div3 .upload-demo .el-upload-list {
      margin-top: 5%;
      height: 160%;
    }
  }
  @media screen and (max-width: 625px) {
    #con1-line6-div3 .upload-demo .el-upload-list {
      margin-top: 0;
      height: 120%;
    }
  }
  @media screen and (max-width: 414px) {
    #con1-line6-div3 .upload-demo .el-upload-list {
      height: 100%;
    }
  }
}
</style>
